import { TextInput, TextInputProps } from "react-admin";

export const DefaultTextInput = (props: TextInputProps) => {
    return (
        <TextInput {...props} style={{ maxWidth: "400px", width: "100%" }} />
    );
};
